import styled from 'styled-components';

export const ContainerRate = styled.div`
  margin: 0px 3px;
`;
